import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import SideBar from "./component/sidebar";
import Navbar from "./component/navbar";

const ProtectedRoute = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const userToken = localStorage.getItem('userjwt');

  // Check screen size on mount and when window resizes
  useEffect(() => {
    document.title = "";
    
    // Set sidebar open by default on desktop
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };

    // Set initial state
    handleResize();
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!userToken) {
    return <Navigate to="/login" />;
  }

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Create an overlay for mobile when sidebar is open
  const Overlay = () => (
    <div 
      className={`fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden ${isSidebarOpen ? 'block' : 'hidden'}`} 
      onClick={toggleSidebar}
    />
  );

  return (
    <div className="flex h-screen overflow-hidden">
      <Overlay />
      <SideBar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="flex flex-col flex-1 w-full">
        <Navbar toggleSidebar={toggleSidebar} />
        <main className="flex-1 overflow-y-auto p-4 transition-all duration-300 md:ml-[272px]">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ProtectedRoute;